<template>
  <div style="border: 1px solid #ccc;">
    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
    <Editor
      style="height: 500px; overflow-y: hidden;"
      v-model="html"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
      @onChange="onChange"
    />
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
export default {
  components: { Editor, Toolbar },
  props: {
    placeholder: {
      type: String,
      default: "请输入内容",
    },
    value: {
      type: String,
      default: "",
    },
    // 是否显示全屏工具栏
    isFullScreen: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      editor: null,
      html: "",
      toolbarConfig: {
        excludeKeys: ["group-video", "group-image"],
      },
      editorConfig: {
        placeholder: "请输入内容",
      },
      mode: "default",
    };
  },
  watch: {
    value: {
      handler(val) {
        this.html = val;
      },
      deep: true,
      immediate: true,
    },
    isFullScreen: {
      handler(val) {
        this.toolbarConfig.excludeKeys = val ? ["group-video", "group-image"] : ["group-video", "group-image", "fullScreen"];
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {},
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    onChange() {
      this.$emit("update:value", this.html);
    },
  },
  mounted() {
    setTimeout(() => {
      this.editorConfig.placeholder = this.placeholder;
    }, 1000);
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>

<style lang="less" scoped>
/deep/ .w-e-text-container [data-slate-editor] p {
  line-height: 0.5;
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
